import React, { useState, useEffect, memo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Alert } from 'reactstrap';
import {useProjectData} from '../contexts/ProjectDataContextProvider';
import {useFilterContext, useFilterDispatch} from '../contexts/FilterContextProvider';
import { filterProjects, updatePathname, removeDuplicates } from '../utils/data';
import FilterSelections from './FilterSelections';
import Loading from './Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';


function ProjectsList() {
  const history = useHistory();
  const {projectData} = useProjectData();
  const filters = useFilterContext();
  const filterDispatch = useFilterDispatch();
  var [filteredProjState, setFilteredProjState] = useState(projectData.projects);

  const selectProject = (e, project) => {
    e.preventDefault();
    var selectedProject = project.FME_PROJ_KEY_NO;
    filterDispatch({
      type: 'projectForSnapshot',
      payload: selectedProject
    });
    updatePathname(history, selectedProject);
  }

  useEffect(() => {
    let newFilteredProjects = filterProjects(projectData.projects, filters.search, filters.location.city.selectedLocation, filters.location.county.selectedLocation, filters.location.region.selectedLocation, filters.location.act.selectedLocation, filters.location.mpo.selectedLocation, filters.location.congDistrict.selectedLocation, filters.location.houseDistrict.selectedLocation, filters.location.senateDistrict.selectedLocation, filters.phase, filters.performance, filters.year, filters.type, filters.admin, filters.selectedForList, filters.extent, filters.mapped);
    newFilteredProjects = removeDuplicates(newFilteredProjects, "FME_PROJ_KEY_NO");
    setFilteredProjState(newFilteredProjects);
  }, [projectData.projects, filters.search, filters.location, filters.phase, filters.performance, filters.year, filters.type, filters.admin, filters.selectedForList, filters.extent, filters.mapped]);
  
  return (
    <>
      {projectData.isLoading ?
        <Loading/>
        :
        projectData.errorOccurred ?
          <Alert color="danger">An error has occurred. Please try refreshing the page. If this error persists, please contact the <a href="mailto:transparency@odot.state.or.us">site administrator.</a></Alert>
          :
          <>
            <h2 className="projects-header">
              {(projectData.projects && projectData.projects.length === filteredProjState.length) ? "All" : filteredProjState.length.toString()} {filteredProjState.length && filteredProjState.length === 1 ? "Project" : "Projects"}
            </h2>
            <div className="filter-selection-wrapper">
              <FilterSelections/>
            </div>
            {
              (filters.performance.length ? <p className="project-no"><strong>Please note:</strong> Performance information is available for completed ODOT construction projects.</p> : "")
            }
            <div style={{overflowY: "auto"}}>
              { filteredProjState && filteredProjState.map(project => {
                  return(
                    <div key={project.FME_PROJ_KEY_NO} id={"proj" + project.FME_PROJ_KEY_NO}>
                      <Link to={"/projects/" + project.FME_PROJ_KEY_NO + window.location.search} onClick={(e) => selectProject(e, project)}>{project.FME_PROJ_NM}</Link>
                      <span className="project-no"> - Project number: {project.FME_PROJ_KEY_NO}{project.FME_MAPPED && project.FME_MAPPED === "TRUE" ? " - Mapped ": ""}{project.FME_MAPPED && project.FME_MAPPED === "TRUE" ? <FontAwesomeIcon icon={faMapMarkerAlt} aria-label="Map Marker" /> : <></>}</span>
                      <hr/>
                    </div>
                  );
                })}
            </div>
          </>
      }
    </>
  );
}

export default memo(ProjectsList);